/* Pair it perfectly in the bag (snippets/pair-it-perfectly.liquid): Add with no size chosen shows the piece's
   sizes as buttons under it ([data-pair-sizes]) instead of trying to open the size list, which phones (iOS
   Safari) don't allow from a button; a tap on a size picks it in the list (so theme.js keeps the choice and
   the price) and adds it to the bag. Runs before theme.js's own Pair handler (capture) and only takes over in
   those two cases. Loaded from sections/cart-drawer.liquid. */
(() => {
  const V = window.Vesari;
  if (!V || !V.cart) return;
  document.addEventListener(
    'click',
    async (e) => {
      if (!(e.target instanceof Element)) return;
      const add = e.target.closest('[data-pair-add]');
      if (add && !add.dataset.pairVariant) {
        const item = add.closest('[data-pair-item]');
        const select = item && item.querySelector('[data-pair-size]');
        const row = item && item.querySelector('[data-pair-sizes]');
        if (select && !select.value && row) {
          e.preventDefault();
          e.stopImmediatePropagation();
          const open = row.classList.contains('hidden');
          row.classList.toggle('hidden', !open);
          row.classList.toggle('flex', open);
          if (open) row.querySelector('[data-pair-pick]:not([disabled])')?.focus({ preventScroll: true });
          return;
        }
      }
      const pick = e.target.closest('[data-pair-pick]');
      if (!pick) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (pick.disabled) return;
      const item = pick.closest('[data-pair-item]');
      item.querySelectorAll('[data-pair-pick]').forEach((b) => {
        b.disabled = true;
        b.setAttribute('aria-pressed', b === pick ? 'true' : 'false');
      });
      pick.classList.remove('bg-paper', 'text-ink', 'border-line');
      pick.classList.add('bg-ink', 'text-paper', 'border-ink');
      const select = item.querySelector('[data-pair-size]');
      if (select) {
        select.value = pick.dataset.pairPick;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const ok = await V.cart.add(pick.dataset.pairPick, 1);
      if (ok === false) item.querySelectorAll('[data-pair-pick]').forEach((b) => (b.disabled = b.classList.contains('line-through')));
    },
    true,
  );
})();
